export const LOGIN_PATH = "/login";
export const DEFAULT_AUTHENTICATED_PATH = "/dashboard";
export const FORBIDDEN_PATH = "/403";
export const DEV_UI_LIBRARY_PATH = "/dev/ui-library";
export const DEVELOP_PATH = "/develop";
export const DEV_CLODOP_TEMPLATE_PATH = `${DEVELOP_PATH}/clodop-template`;
export const DEV_PRINT_DESIGNER_PATH = `${DEVELOP_PATH}/print-designer-debug`;
export const DEV_PLATFORM_PRINT_PATH = `${DEVELOP_PATH}/platform-print-debug`;

export const WHITE_LIST_ROUTERS = [LOGIN_PATH, FORBIDDEN_PATH];

export const USER_INFO_TTL = 60 * 1000;
export const PERMISSION_ROUTES_TTL = 3 * 60 * 1000;
